import Vuex from "vuex";
import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
//comment

Vue.use(Vuex);
Vue.use(VueAxios, axios);

export default new Vuex.Store({
  state: {
    darkMode: true,
    eventsLoading: true,
    events: [],
    progress: 1,
    questionsCount: 7,
    services: [],
    service_terms: [],
    continuumDialog: false,
    help_dialog_swap: false,
    views: {
      homepage: {
        status: true,
      },

      questionOne: {
        status: false,
        openHelpDialog: true,
        openWarningDialog: true,
        answer: [],
        checkedButtons: [],
        checkedSlider: "Mild",
        nextPartofQuestion: [false, false],
        nextButtonActive: false,
      },

      questionTwo: {
        status: false,
        answer: [],
        //the last index for the 2 arrays below represent the the special question if the user selects "undergraduate"
        checkedButtons: [],
        nextPartofQuestion: [false, false, false],
        nextButtonActive: false,
      },

      questionTen: {
        status: false,
        answer: [],
        checkedButtons: [],
        nextButtonActive: false,
      },

      questionThree: {
        status: false,
        answer: [],
        checkedButtons: [],
        nextButtonActive: false,
      },

      questionFour: {
        status: false,
        answer: [],
        checkedButtons: [],
        nextButtonActive: false,
      },

      questionFive: {
        status: false,
        answer: [],
        checkedButtons: [],
        nextButtonActive: false,
      },

      questionSix: {
        status: false,
        answer: [],
        checkedButtons: [],
        nextButtonActive: false,
      },
      questionSeven: {
        status: false,
        answer: [],
        checkedButtons: [],
        nextPartofQuestion: [false],
        nextButtonActive: false,
      },

      questionEight: {
        status: false,
        answer: [],
        checkedButtons: [],
        nextButtonActive: false,
      },

      questionNine: {
        status: false,
        answer: [],
        checkedButtons: [],
        nextButtonActive: false,
      },

      results: {
        status: false,
      },
    },
  },
  getters: {
    services: (state) => {
      return state.services;
    },
    service_terms: (state) => {
      return state.service_terms;
    },

    questionOneAnswer: (state) => {
      return state.views.questionOne.answer[0];
    },

    questionTwoAnswer: (state) => {
      return state.views.questionTwo.answer[0];
    },

    questionThreeAnswer: (state) => {
      return state.views.questionThree.answer[0];
    },

    questionFourAnswer: (state) => {
      return state.views.questionFour.answer[0];
    },

    questionFiveAnswer: (state) => {
      return state.views.questionFive.answer[0];
    },

    questionSixAnswer: (state) => {
      return state.views.questionSix.answer[0];
    },

    questionEightAnswer: (state) => {
      return state.views.questionEight.answer[0];
    },
    questionTenAnswer: (state) => {
      return state.views.questionTen.answer[0];
    },

    questionOneCheckButtons: (state) => {
      return state.views.questionOne.checkedButtons;
    },

    questionTwoOption: (state) => {
      return state.views.questionTwo.checkedButtons[3];
    },

    events: (state) => {
      return state.events;
    },

    darkModeState: (state) => {
      return state.darkMode;
    },

    warningModal: (state) => {
      return state.views.questionOne.openWarningDialog;
    },

    // filteredItems: (state) => {
    //   if( state.currentCategory == null ||
    //      state.currentCategory.length == 0 ) {
    //     return state.items;
    //   }
    //   return state.items.filter( itm => itm.category == state.currentCategory );
    // }
  },
  mutations: {
    SET_SWAP_DIALOG(state) {
      state.help_dialog_swap = true;
    },
    SET_CURRENT_CATEGORY(state, category) {
      state.currentCategory = category;
    },
    SET_SERVICES(state, services) {
      state.services = services;
    },

    SET_EVENTS(state, events) {
      state.events = events;
      //console.log(events);
    },

    SET_EVENTS_LOADING(state) {
      state.eventsLoading = !state.eventsLoading;
      //console.log(state.eventsLoading);
    },

    changeDarkMode(state, val) {
      state.darkMode = val;
    },

    changeDarkModeSwap(state) {
      state.darkMode = !state.darkMode;
    },

    //set the checked buttons for each page once the user clicks "next" , this allows for the user to go back to antoher question and have their answer saved

    setChecked: (state, { questionNum, checkedButtons }) => {
      var page = JSON.parse(questionNum);

      //console.log(checkedButtons);

      state.views[page].checkedButtons = checkedButtons;

      //certain actions are different for questions with multipart questions (Q1 , Q2 , Q7)

      if (page[0] === "questionOne") {
        if (state.views.questionOne.checkedButtons.length == 11) {
          state.views[page].nextPartofQuestion[0] = true;
        } else if (state.views.questionOne.checkedButtons.length == 12) {
          state.views[page].nextPartofQuestion[0] = true;
          state.views[page].nextPartofQuestion[1] = true;
        } else {
          state.views[page].nextPartofQuestion[0] = false;
        }
      } else if (page[0] === "questionTwo") {
        var i;
        if (checkedButtons.length === 3) {
          for (
            i = 0;
            i < state.views[page].nextPartofQuestion.length - 1;
            i++
          ) {
            state.views[page].nextPartofQuestion[i] = true;
          }
        } else {
          for (i = 0; i < state.views[page].nextPartofQuestion.length; i++) {
            state.views[page].nextPartofQuestion[i] = true;
          }
        }
      }

      if (page[0] === "questionSeven") {
        if (state.views.questionSeven.checkedButtons.length == 9) {
          state.views[page].nextPartofQuestion[0] = true;
        } else {
          state.views[page].nextPartofQuestion[0] = false;
        }
      }
    },

    //only for Q1
    setSlider: (state, mood) => {
      state.views.questionOne.checkedSlider = mood;
    },

    //increase progress of questions and add to the answer array and service terms array
    addAnswer: (state, { index, ans }) => {
      var page = JSON.parse(index);
      state.views[page].answer.push(ans);
      state.progress = state.progress + 1;
      // state.progress = state.progress++;
      //console.log(state.views[page].answer);
      state.progressBarClass = state.progress + 1;
      state.service_terms.push(ans);

      // state.service_terms.flat(1);
      var newServiceArray = Array.prototype.concat.apply(
        [],
        state.service_terms
      );
      state.service_terms = newServiceArray;
    },

    //when going back , remove the answer that was previously pushed to the array and be replace with new answer about to be added
    removeAnswer: (state, index) => {
      var page = JSON.parse(index);
      state.views[page].answer.splice(0, state.views[page].answer.length);
      state.progress = state.progress - 1;
      state.service_terms.splice(state.progress - 1);
    },

    //removing the next part of each question , index is for which part of the mutli step
    removeNextQuestions: (state, { index, questionNum }) => {
      var page = JSON.parse(index);
      state.views[page].nextPartofQuestion[questionNum] = false;
    },

    setNextButtonActive: (state, index) => {
      var page = JSON.parse(index);

      state.views[page].nextButtonActive = true;
    },

    setNextButtonDeactive: (state, index) => {
      var page = JSON.parse(index);

      state.views[page].nextButtonActive = false;
    },

    //since the back button is a component , this is to determine which question is active
    findActiveQuestion: (state) => {
      var activePage;
      Object.keys(state.views).forEach(function (key) {
        if (state.views[key].status === true) {
          activePage = key;
          //this function is at the bottom of the index.js
          goBackUpdate(activePage, state);
        }
      });
    },

    //if the user decides to quit or start over again , this will make the navigator new again , in terms of all the buttons
    resetAllActiveButtons: (state) => {
      //reset the array of each checked answers and remove the next button from being active

      Object.keys(state.views).forEach(function (key) {
        if (
          JSON.stringify(key) !== JSON.stringify("homepage") &&
          JSON.stringify(key) !== JSON.stringify("results")
        ) {
          state.views[key].checkedButtons.length = 0;
          state.views[key].nextButtonActive = false;
        }
      });

      //reset the nextPart of each question
      state.views.questionOne.nextPartofQuestion.fill(false);
      state.views.questionTwo.nextPartofQuestion.fill(false);
      state.views.questionSeven.nextPartofQuestion.fill(false);
    },

    //if the user decides to quit or start over again , this will make the navigator new again , in terms of all the answers
    clearAnswers: (state) => {
      Object.keys(state.views).forEach(function (key) {
        if (
          JSON.stringify(key) !== JSON.stringify("homepage") &&
          JSON.stringify(key) !== JSON.stringify("results")
        ) {
          state.views[key].answer.length = 0;
        }
      });
      state.views.questionOne.checkedSlider = "Mild";
      state.service_terms.length = 0;
    },

    //set the index page to true and the rest to false
    updatePage: (state, index) => {
      var page = JSON.parse(index);
      state.views[page].status = true;

      if (state.views.homepage.status == true) {
        state.progress = 1;
      }
      //set all others to false
      Object.keys(state.views).forEach(function (key) {
        if (!(key === page[0])) {
          state.views[key].status = false;
        }
      });
    },

    closeHelpDialog: (state) => {
      state.views.questionOne.openHelpDialog = false;
    },

    closeWarningDialog: (state) => {
      state.views.questionOne.openWarningDialog = false;
    },
    closeContinuumDialog: (state) => {
      state.continuumDialog = true;
    },
  },

  actions: {
    appendServiceTerm(state, payload) {
      state.commit("APPEND_SERVICE_TERM", payload);
    },
    loadServices({ commit }) {
      var url;
      if (window.location.hostname == "localhost") {
        //url = "http://localhost:8080/services.json";
        url =
          "https://students.carleton.ca/wp-json/stu-api/v2/services/navigator";
      } else {
        // url = "https://wellness-dev.carleton.ca/navigator/services.json";
        url =
          "https://students.carleton.ca/wp-json/stu-api/v2/services/navigator";
      }
      axios
        //.get(
        //"https://students-dev.carleton.ca/wp-json/stu-api/v2/services/navigator"
        //)
        // )/
        //.get("http://localhost:8080/services.json")
        .get(url)
        //.get(
        // "https://students.carleton.ca/wp-json/stu-api/v2/services/navigator"
        //)
        .then((response) => response.data)
        .then((services) => {
          //console.log(services);
          commit("SET_SERVICES", services);
        });
    },
  },
});

//helper function for going back
function goBackUpdate(activePage, state) {
  var tempArray = [];
  var i;

  var arrayOfPages = [
    "homepage",
    "questionOne",
    "questionTwo",
    "questionTen",
    "questionThree",
    "questionFour",
    "questionFive",
    "questionEight",
    "results",
  ];

  for (i = 0; i < arrayOfPages.length; i++) {
    //find the page that is currently active
    if (activePage === arrayOfPages[i]) {
      //updatePage
      state.views[arrayOfPages[i]].status = false;
      state.views[arrayOfPages[i - 1]].status = true;

      //remove answer
      if (!(arrayOfPages[i - 1] === "homepage")) {
        let remove_previous_ans_length =
          state.service_terms.length -
          state.views[arrayOfPages[i - 1]].answer[0].length;

        state.views[arrayOfPages[i - 1]].answer.splice(
          0,
          state.views[arrayOfPages[i - 1]].answer.length
        );
        state.progress -= 1;

        state.service_terms.splice(
          remove_previous_ans_length,
          state.service_terms.length
        );
      }

      //console.log(arrayOfPages[i]);
      //console.log(state.views[arrayOfPages[i]].checkedButtons.length);

      //if the user currently had an answer selected **if the user went back to a question , made changes that affected the state , and then went back to another question
      //without clicked "next" which saves to the state , bugs arise , this code below is helping fix those issues
      if (!(state.views[arrayOfPages[i]].checkedButtons.length === 0)) {
        //create a copy of the checkedbuttons array so the original one does not changed
        for (
          var j = 0;
          j < state.views[arrayOfPages[i]].checkedButtons.length;
          j++
        ) {
          tempArray.push(state.views[arrayOfPages[i]].checkedButtons[j]);
        }

        //if its not 0 and there is one value that is different from NULL then the next button must remain active

        /*

        radio buttons - array gets filled with the id of the checked buttons , so if the the array is 0 , then there is 0 checked buttons 

        checked buttons - array gets filled with the id of the checked buttons , when searching all checkboxes , 'NULL' will get added to the index if it is not checked 
        so the helperfunction "checkForNullCheckedButtons" will dtermine if at least one checkbox was checked , also this is different from radio as the length will never be 0 
        (all could be 'NULL) so both conditions need to be checked 

        */

        //state.views.questionOne.nextPartofQuestion[1] = true;

        if (tempArray.length !== 0 && !checkForNullCheckedButtons(tempArray)) {
          state.views[arrayOfPages[i]].nextButtonActive = true;

          //for question One
          //if the user deselects one of the buttons that shows the slider , and go backs without clicking next (AKA saving to the state) display the next part of the question
          if (
            arrayOfPages[i] === "questionOne" &&
            (state.views[arrayOfPages[i]].checkedButtons[8] !== "NULL" ||
              state.views[arrayOfPages[i]].checkedButtons[9] !== "NULL")
          ) {
            state.views[arrayOfPages[i]].nextPartofQuestion[0] = true;
          }
          if (
            arrayOfPages[i] === "questionOne" &&
            (state.views[arrayOfPages[i]].checkedSlider === "Severe" ||
              state.views[arrayOfPages[i]].checkedSlider === "Extremely severe")
          ) {
            state.views[arrayOfPages[i]].nextPartofQuestion[1] = true;
          }

          //for questions Two
          //if the user selects undergrauate , comes back to the questions , selects graduate , and then goes back a quesitons without saving to state (clicking "next")
          else if (
            arrayOfPages[i] === "questionTwo" &&
            state.views[arrayOfPages[i]].checkedButtons[0] === "option1"
          ) {
            state.views[arrayOfPages[i]].nextPartofQuestion[2] = true;
          }
          /*else if (
            arrayOfPages[i] === "questionSeven" &&
            state.views[arrayOfPages[i]].checkedButtons[1] !== "NULL"
          ) {
            state.views[arrayOfPages[i]].nextPartofQuestion[0] = true;
          }
          */
        }
      }
    }
  }
  if (state.views.homepage.status == true) {
    state.progress = 1;
  }
}


//function to determine if all values in the array are the same
function checkForNullCheckedButtons(arr) {
  arr.sort();
  return arr[0] == arr[arr.length - 1];
}
